import { Skeleton } from '@/components/ui/skeleton'

interface Props {
  isSidebarExpanded: boolean
}

export const ChatItemSkeleton = ({ isSidebarExpanded }: Props) => {
  return (
    <div className="flex gap-3 px-4 pt-4">
      <div className="mb-4">
        <Skeleton className="h-[50px] w-[50px] rounded-full dark:bg-skeleton" />
      </div>
      {isSidebarExpanded && (
        <div className="flex w-full flex-col justify-between border-b pb-4">
          <Skeleton className="h-5 w-[220px] dark:bg-skeleton" />
          <Skeleton className="h-4 w-[150px] dark:bg-skeleton" />
        </div>
      )}
    </div>
  )
}
